import type { ParsedUrlQuery } from 'querystring'

export type ConnectParams = {
  cookieLogin: {
    clientId: string
    redirectUri: string
  } | null
}

export type ConnectParamsQuery = {
  client_id?: string
  redirect_uri?: string
}

export const toConnectParamsQuery = (params: ConnectParams): ConnectParamsQuery => {
  return params.cookieLogin
    ? {
        client_id: params.cookieLogin.clientId,
        redirect_uri: params.cookieLogin.redirectUri,
      }
    : {}
}

export const getParams = (query: ParsedUrlQuery): ConnectParams => {
  const clientId = typeof query.client_id === 'string' ? query.client_id : undefined
  const redirectUri = typeof query.redirect_uri === 'string' ? query.redirect_uri : undefined

  return {
    cookieLogin:
      clientId && redirectUri
        ? {
            clientId,
            redirectUri,
          }
        : null,
  }
}

export const toSearchParams = (params: ConnectParams, base?: URLSearchParams) => {
  const s = new URLSearchParams(base)
  if (params.cookieLogin) {
    s.append('client_id', params.cookieLogin.clientId)
    s.append('redirect_uri', params.cookieLogin.redirectUri)
  }

  return s
}
